export const API = Object.freeze({
  USER: 'USER',
  MOCHI_USER: 'MOCHI_USER',
  PAYMENT: 'PAYMENT',
  PICKNCHARGE: 'PICKNCHARGE',
  CONTACT: 'CONTACT',
  MEDIA_CENTER: 'MEDIA_CENTER',
});
